import Event from "@components/event/Event";

const EventPage = ({ siteConfig }) => {
  return <Event />;
};
export default EventPage;
